import { agentConnectionManager } from '@/pages/Board/components/ui-session/utils/agentConnectionManager';
import { useEffect, useCallback, useState } from 'react';

export const useAgentConnection = () => {
  const [connected, setConnected] = useState<boolean>(agentConnectionManager.isConnected());
  const [connecting, setConnecting] = useState<boolean>(agentConnectionManager.isConnectingNow());

  useEffect(() => {
    const unsubscribe = agentConnectionManager.subscribe((isConnected) => {
      setConnected(isConnected);
      setConnecting(agentConnectionManager.isConnectingNow());
    });
    return unsubscribe;
  }, []);

  const initializeConnection = useCallback(() => {
    agentConnectionManager.start();
    setConnecting(agentConnectionManager.isConnectingNow());
  }, []);

  const cleanup = useCallback(() => {
    agentConnectionManager.stop();
    setConnecting(false);
    setConnected(false);
  }, []);

  useEffect(() => {
    return cleanup;
  }, [cleanup]);

  return {
    initializeConnection,
    cleanup,
    isConnected: connected,
    isConnecting: connecting,
  };
};
